import { useState } from 'react';
export function useSyncedState(source, init) {
    const derive = (value) => (init ? init(value) : value);
    const [state, setState] = useState(() => derive(source));
    const [from, setFrom] = useState({ source });
    if (!Object.is(from.source, source)) {
        setFrom({ source });
        setState(() => derive(source));
    }
    return [state, setState];
}
//# sourceMappingURL=use-synced-state.js.map